/**
 * Raam voor de pagina's die in W5-2 en W5-3 pas herbouwd worden
 * (Klanten, Retouren, Reviews, Signalen, Kennis, Gezondheid, Beheer,
 * Voorraad). Ze draaien ongewijzigd onder de nieuwe menubalk, met de
 * tokens, de meekijk-context en het belpaneel die ze van de v4-schil
 * gewend waren. Dit is het enige bestand van v6 dat v4-onderdelen
 * aanraakt, en het verdwijnt zodra die pagina's herbouwd zijn.
 */
import { Outlet } from "react-router-dom";

import "@/styles/werkplek-tokens.css";

import { KijktMeeProvider } from "../Werkplek/Copiloot/kijktMee";
import { LosBelpaneel } from "../Werkplek/Tegel/LosBelpaneel";

export function OudScherm() {
  return (
    <KijktMeeProvider>
      <div className="v6-oudvlak">
        <div className="werkplek">
          <Outlet />
          <LosBelpaneel />
        </div>
      </div>
    </KijktMeeProvider>
  );
}
